import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ScaAuthenticationEventChallengeEmbeddedHybridResponse
} from '@paysafe/paysafe-wallet-saas-web/common';

import { ScaDetails } from '../../../models/payment/session-payment-response.model';
import { ScaStep } from '../../../models/sca/sca-step.enum';
import { CheckoutErrorComponent } from '../../checkout-error/checkout-error.component';
import { ScaCodeVerificationComponent } from '../sca-code-verification/sca-code-verification.component';
import { ScaMethodSelectionComponent } from '../sca-method-selection/sca-method-selection.component';

@Component({
  selector: 'app-sca-modal',
  templateUrl: './sca-modal.component.html',
  styleUrls: ['./sca-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, ScaMethodSelectionComponent, ScaCodeVerificationComponent, CheckoutErrorComponent]
})
export class ScaModalComponent {
  @Input() scaDetails: ScaDetails;

  @Output() close = new EventEmitter<void>();
  @Output() verified = new EventEmitter<void>();
  @Output() error = new EventEmitter<void>();

  currentStep: ScaStep = ScaStep.METHOD_SELECTION;
  activeChallenge: ScaAuthenticationEventChallengeEmbeddedHybridResponse;

  protected readonly ScaStep = ScaStep;

  onVerificationMethodSelected(response: ScaAuthenticationEventChallengeEmbeddedHybridResponse): void {
    this.activeChallenge = response;
    this.currentStep = ScaStep.CODE_VERIFICATION;
  }

  onChooseDifferentOption(): void {
    this.activeChallenge = null;
    this.currentStep = ScaStep.METHOD_SELECTION;
  }

  onVerificationSuccess(): void {
    this.verified.emit();
  }

  onClose(): void {
    this.close.emit();
  }

  onError(): void {
    this.currentStep = ScaStep.ERROR;
    this.error.emit();
  }

  onErrorPrimaryAction = (): void => {
    this.currentStep = ScaStep.METHOD_SELECTION;
  };

}
